import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/alt-text */

/* Original name @uswitch/trustyle.hero */
import * as React from 'react';
import { useThemeUI } from 'theme-ui';
import { path } from '@uswitch/ev-utils/obj';
import { Palette } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var makeStyles = function makeStyles(variant) {
  return function (element) {
    return "elements.hero".concat(variant ? ".variants.".concat(variant) : '').concat(element ? ".".concat(element) : '');
  };
};

var DefaultContainer = function DefaultContainer(_ref) {
  var children = _ref.children;
  return _jsx("div", {
    sx: {
      maxWidth: 1024,
      margin: '0 auto',
      paddingX: 10
    },
    children: children
  });
};

var Hero = function Hero(_ref2) {
  var breadcrumbs = _ref2.breadcrumbs,
      _ref2$container = _ref2.container,
      Container = _ref2$container === void 0 ? DefaultContainer : _ref2$container,
      fgImage = _ref2.fgImage,
      _ref2$fgImageType = _ref2.fgImageType,
      fgImageType = _ref2$fgImageType === void 0 ? 'background' : _ref2$fgImageType,
      fgImagePosition = _ref2.fgImagePosition,
      _ref2$fgImageOnMobile = _ref2.fgImageOnMobile,
      fgImageOnMobile = _ref2$fgImageOnMobile === void 0 ? false : _ref2$fgImageOnMobile,
      _ref2$fgImageOnTablet = _ref2.fgImageOnTablet,
      fgImageOnTablet = _ref2$fgImageOnTablet === void 0 ? false : _ref2$fgImageOnTablet,
      _ref2$customBgColor = _ref2.customBgColor,
      customBgColor = _ref2$customBgColor === void 0 ? '' : _ref2$customBgColor,
      children = _ref2.children,
      variant = _ref2.variant,
      _ref2$bottomImageOver = _ref2.bottomImageOverflow,
      bottomImageOverflow = _ref2$bottomImageOver === void 0 ? '-33%' : _ref2$bottomImageOver,
      className = _ref2.className;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var styles = makeStyles(variant);
  var breadcrumbVariant = path(styles('breadcrumbs.variant').split('.'), theme);
  var breadcrumbWithVariant = breadcrumbs && /*#__PURE__*/React.cloneElement(breadcrumbs, {
    variant: breadcrumbVariant
  });
  return _jsxs("div", {
    children: [_jsx(Palette, {
      as: "div",
      sx: {
        overflow: 'hidden',
        variant: styles('wrapper')
      },
      px: {
        backgroundColor: 'backgroundColor'
      },
      children: _jsx("div", {
        sx: {
          position: 'relative',
          overflow: 'hidden',
          background: customBgColor || undefined
        },
        className: className,
        children: _jsxs(Container, {
          sx: {
            variant: styles('container')
          },
          children: [breadcrumbs ? _jsx("div", {
            sx: {
              paddingTop: 'sm',
              variant: styles('breadcrumbs')
            },
            children: breadcrumbWithVariant
          }) : null, _jsxs("div", {
            sx: {
              position: 'relative',
              display: 'block',
              flexDirection: 'row-reverse'
            },
            children: [_jsx("div", {
              sx: _objectSpread(_objectSpread({
                position: 'absolute',
                left: [0, '45%'],
                right: 0,
                top: 0,
                bottom: 0,
                display: [fgImageOnMobile ? 'block' : 'none', fgImageOnTablet ? 'block' : 'none', 'block']
              }, fgImage && fgImageType === 'background' ? _objectSpread({
                backgroundImage: "url(".concat(fgImage, ")"),
                backgroundRepeat: 'no-repeat'
              }, fgImagePosition) : undefined), {}, {
                variant: styles('image')
              }),
              children: fgImage && fgImageType === 'img' ? _jsx("img", {
                sx: _objectSpread({
                  maxWidth: '100%',
                  position: 'absolute'
                }, fgImagePosition),
                src: fgImage,
                role: "presentation"
              }) : null
            }), _jsx("div", {
              sx: {
                position: 'relative',
                paddingTop: ['sm', 'xxl'],
                paddingBottom: ['sm', 'xxl'],
                variant: styles('content')
              },
              children: children
            })]
          })]
        })
      })
    }), fgImage ? _jsx("img", {
      sx: {
        maxWidth: '100%',
        position: 'relative',
        display: 'none',
        marginTop: "-".concat(bottomImageOverflow),
        marginLeft: 'auto',
        marginRight: 'auto',
        variant: styles('bottomImage')
      },
      src: fgImage,
      role: "presentation"
    }) : null]
  });
};

export default Hero;
//# sourceMappingURL=index.js.map